@if (!isLoading()) {
<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.NEW-CHAT.createANewDirectChannel' | translate | uppercase }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="newChatForm">
    <mat-form-field appearance="fill" class="full-width-input">
      <input placeholder="Co-Workers" matInput formControlName="availableUser" [matAutocomplete]="auto" />
      <mat-autocomplete (optionsScroll)="onScroll()" #auto="matAutocomplete" [displayWith]="getOptionText" multiple>
        @for (option of users(); track option.uid) {
        <mat-option [value]="option">
          {{ option.displayName }}
        </mat-option>
        } @if (loadingUsers()) {
        <mat-option> {{ 'NGX-MESSAGING.searching' | translate }} </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width-input">
      <textarea
        matInput
        cdkAutosizeMaxRows="10"
        [maxlength]="250"
        formControlName="description"
        placeholder="{{ 'NGX-MESSAGING.NEW-CHAT.writeAMessage' | translate }}"></textarea>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="chat-input__button"
    color="primary"
    (click)="sendMessage()"
    [disabled]="!newChatForm.valid">
    {{ 'NGX-MESSAGING.NEW-CHAT.createChannel' | translate }}
  </button>
</div>
} @else {
<ngx-text-spinner [text]="'Creating direct channel'"></ngx-text-spinner>
}
